import React, { useCallback, useMemo } from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

// Rochester, Kent coordinates
const DEFAULT_CENTER = {
  lat: 51.3755,
  lng: 0.5032
};

const MARKER_POSITION = {
  lat: 51.3772,  // Approximate position for 11 Moore Street
  lng: 0.5021
};

const containerStyle = {
  width: '100%',
  height: '100%'
};

const GoogleMapComponent = () => {
  // Load the Google Maps JavaScript API
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''
  });

  // Options for the map
  const options = useMemo(() => ({
    disableDefaultUI: false,
    clickableIcons: true,
    scrollwheel: false,
    styles: [
      {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#081F34' }]
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#CFFF81' }]
      }
    ]
  }), []);

  // On map load callback
  const onLoad = useCallback(function callback(map) {
    // We can use the map object here if needed in the future
    // For now, we don't need to store it in state
  }, []);

  // On map unmount callback
  const onUnmount = useCallback(function callback() {
    // Clean up logic if needed
  }, []);

  // Handle loading error
  if (loadError) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-primary/10 text-primary">
        Error loading maps
      </div>
    );
  }

  // Show loading state
  if (!isLoaded) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-primary/10 text-primary">
        Loading maps...
      </div>
    );
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={DEFAULT_CENTER}
      zoom={14}
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={options}
    >
      <Marker position={MARKER_POSITION} />
    </GoogleMap>
  );
};

export default GoogleMapComponent;